<script>
    import ClickOutside from "svelte-click-outside";
    import Input from "../../pages/permissionless/input-design/Input.svelte";
    import NETWORKS, {NETWORK_CHAIN_IDS} from "../../constants/network";
    import {formattedChainID, switchAddNetwork} from "../../utils";
    import {chainId} from "svelte-ethers-store";

    export let dropDownArrow;
    let selectedChain = "", chainDropdown, triggerEl;

    let blockchains = Object.fromEntries(Object.entries(NETWORK_CHAIN_IDS).map(([key,value]) => ([value,key])));

   $: if($chainId) {
       selectedChain = blockchains[formattedChainID($chainId)] ?? "";
    }

    const handleAddress = (chainID) => {
        if(formattedChainID($chainId) !== chainID){
            switchAddNetwork(chainID)
        }
        chainDropdown = false;
    };
</script>

<div class="drop-field">
    <Input
            bind:value={selectedChain}
            id="reserve-token"
    >
        <label for="reserve-token" slot="label" class="form-label">
            Select Chain
            <small>*</small>
        </label>
        <span
                slot="label_dec"
                class="form-label-dec relative flex flex-text-center"
        >
        <small class="mr-auto">
          Please enter the recipient
        </small>
      </span>
    </Input>
    <img
        class={`drop-icon ${chainDropdown ? "tokenDropdown" : ""}`}
        id="token-drop"
        src={dropDownArrow}
        alt=""
        on:click={() => (chainDropdown = !chainDropdown)}
        bind:this={triggerEl}
    />
    <ClickOutside
        on:clickoutside={() => (chainDropdown = false)}
        exclude={[triggerEl]}
    >
        <div class={`token-dropdown selectchain ${chainDropdown ? "tokenDropdown" : ""}`}>
            <ul class="list-none flex column-direction">
                {#each Object.keys(blockchains) as chainId}
                    <li on:click={() => handleAddress(chainId)}>
                        <img src={NETWORKS[chainId]?.iconUrl} alt="" />
                        {blockchains[chainId]}
                    </li>
                {/each}
            </ul>
        </div>
    </ClickOutside>
</div>
